import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppAuthNService, User} from './services/app-auth-n.service';
import { PageDatatableModel } from './shared/models/page-datatable.model';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']

})

export class AppComponent implements OnInit {

  private homePath: string = "home";
  private loginPath: string = "login";
  loading: boolean = false; 
  title = 'GiftCardVirtual';
  stickyToasties: number[] = [];
  isCollapsed: Boolean = true;
  isAuthorizedSubscription: Subscription;
  isAuthorized: Boolean = false;
  token: string;
  messages: string[] = [];
  currentUser: User;
  page: PageDatatableModel = new PageDatatableModel();
  loadedData: boolean = false;

  constructor(public authn: AppAuthNService,
              public router: Router
            ){}
   
  ngOnInit() {
    //debugger;
    var tokenSession = localStorage.getItem("access_token");
    if (tokenSession == null || tokenSession == undefined || tokenSession == '') {
      this.loading = false;
      this.router.navigate([this.loginPath]);
    } else {
      this.loading = true;
      this.router.navigate([this.homePath]);
    }
  }

  navigateTo($event, path) {
    //debugger;
    if (path == this.homePath)
      this.loading = true;
    else
      this.loading = false;
    this.router.navigate([path]);
  }

  ngOnDestroy(): void {

  }

  menuTo(event){
    
  }
}
